import { aiToken } from './license';

// photo documentation AI: speech -> text, photo description / tags, report summary
const API = `${process.env.REACT_APP_BACKEND_URL}/api/photo`;
const lang = () => localStorage.getItem('baustelle_app_lang') || 'de';

// customer's own AI key (stays on this device, sent only with AI requests)
const BYOK = 'giss_ai_byok';
export const getByok = () => { try { return JSON.parse(localStorage.getItem(BYOK)) || {}; } catch { return {}; } };
export const setByok = (v) => localStorage.setItem(BYOK, JSON.stringify(v));
export const aiHeaders = () => { const b = getByok(); return b.on && b.key && b.provider ? { 'X-AI-Key': b.key, 'X-AI-Provider': b.provider, ...(b.model ? { 'X-AI-Model': b.model } : {}) } : {}; };

async function post(path, body, json = true) {
  const res = await fetch(`${API}/${path}`, { method: 'POST', headers: { ...(json ? { 'Content-Type': 'application/json' } : {}), 'X-License-Token': await aiToken(), ...aiHeaders() }, body: json ? JSON.stringify({ lang: lang(), ...body }) : body });
  if (!res.ok) { const d = await res.json().catch(() => ({})); throw new Error(res.status === 402 ? 'license' : (res.status === 424 || d.detail === 'byok') ? 'byok' : `http ${res.status}`); }
  return res.json();
}

// speech recognition language: the language last detected by the AI, else the app language
const SL = { de: 'de-DE', en: 'en-GB', it: 'it-IT', es: 'es-ES', pt: 'pt-PT', fr: 'fr-FR', sq: 'sq-AL' };
export const speechLang = (t) => { const s = localStorage.getItem('giss_speech_lang'); return (s && (SL[s] || s)) || t.locale; };

export async function aiTranscribe(blob) {
  const fd = new FormData();
  fd.append('file', blob, 'note');
  fd.append('lang', lang());
  const r = await post('transcribe', fd, false);
  if (r.lang) localStorage.setItem('giss_speech_lang', r.lang);
  return r.text || '';
}

export const photoNote = (p) => [p.caption, ...(p.memos || []).map((m) => m.transcript)].filter(Boolean).filter((v, i, a) => a.indexOf(v) === i).join(' – ');
export const aiDescribe = (p, sector) => post('describe', { image_base64: p.data, note: photoNote(p), sector });
export const aiSummary = (items, title) => post('summary', { items, title }).then((d) => d.summary);
export const aiBook = (style, title, activity, chapters) => post('book', { style, title, activity, chapters });
